import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Wallet from '@components/account/Wallet';
import AddressBook from '@components/account/AddressBook';
import User from '@modules/User';
import {Show} from '@ultradent/components';
import Icon from '@components/common/Icon';

const PaymentSelector = ( {
                              selectedAddressOption,
                              selectedPaymentOption,
                              paymentOptions,
                              addressBook,
                              allowAddPaymentMethod,
                              onPaymentOptionChange,
                              onPaymentAdded,
                              onAddressAdded,
                              onAddressChange,
                              allowEdit,
                              errors = {}
                          } ) => {

    const [paymentMethodDefault, setPaymentMethodDefault] =
        useState( selectedPaymentOption || User.Wallet.getDefaultPaymentMethod( paymentOptions ) );
    const [addressDefault, setAddressDefault] = useState( selectedAddressOption );
    const [paymentMethodType, setPaymentMethodType] = useState( selectedPaymentOption?.paymentMethodType );

    useEffect( () => {
        setAddressDefault( selectedAddressOption );
        setPaymentMethodDefault( selectedPaymentOption || User.Wallet.getDefaultPaymentMethod( paymentOptions ) );
        setPaymentMethodType( selectedPaymentOption?.paymentMethodType );
    }, [selectedAddressOption, selectedPaymentOption] );

    if ( !allowEdit ) {
        return (
            <div className="lg:flex items-start w-full justify-between">
                <h2 className="subheading-lg mb-4 lg:w-1/3">Payment Method</h2>
                <div className="flex flex-auto">
                    <div className="w-8 items-start">
                        <Icon.ui name="checkmark" className="text-lg text-success mr-2"/>
                    </div>
                    <div>
                        <h3 className="subheading-sm mb-1">
                            Your order will be billed through your corporate or billing office.
                        </h3>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <div className="my-8">
                <Wallet
                    id="wallet"
                    className="mt-4"
                    groupId="SelectedPaymentMethod"
                    paymentMethods={paymentOptions}
                    addressBook={addressBook}
                    defaultPaymentMethod={paymentMethodDefault}
                    allowAddItem={allowAddPaymentMethod}
                    onPaymentOptionChange={onPaymentOptionChange}
                    onPaymentAdded={onPaymentAdded}
                    onAddressAdded={onAddressAdded}
                    error={errors?.paymentOption}
                />
            </div>
            <Show when={paymentMethodType === 'terms'}>
                <div className="checkout-billing-address my-8">
                    <AddressBook
                        id="addressbook"
                        label="Billing Address"
                        groupId="SelectedBillingAddress"
                        addresses={addressBook}
                        defaultAddress={addressDefault}
                        onAddressChange={onAddressChange}
                        error={errors?.billingAddress}
                    />
                </div>
            </Show>
        </div>
    )
}

PaymentSelector.defaultProps = {
    allowEdit: true
}
PaymentSelector.propTypes = {
    selectedAddressOption: PropTypes.object,
    selectedPaymentOption: PropTypes.object,
    paymentOptions: PropTypes.array,
    addressBook: PropTypes.array,
    allowAddPaymentMethod: PropTypes.bool,
    onPaymentOptionChange: PropTypes.func,
    onPaymentAdded: PropTypes.func,
    onAddressAdded: PropTypes.func,
    onAddressChange: PropTypes.func,
    allowEdit: PropTypes.bool,
    errors: PropTypes.object
}

export default PaymentSelector;
